import React from "react";
import { Search } from "lucide-react";

interface Candidate {
  readonly name: string;
  readonly role: string;
  readonly avatarUrl: string;
}

const candidates: readonly Candidate[] = [
  {
    name: "Ava Thompson",
    role: "Frontend Engineer",
    avatarUrl: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64/1f469-200d-1f4bb.png",
  },
  {
    name: "Liam Chen",
    role: "Backend Engineer",
    avatarUrl: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64/1f468-200d-1f4bb.png",
  },
  {
    name: "Noah Patel",
    role: "Product Manager",
    avatarUrl: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64/1f9d1-200d-1f4bc.png",
  },
  {
    name: "Emma Garcia",
    role: "Designer",
    avatarUrl: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64/1f469-200d-1f3a8.png",
  },
  {
    name: "Ethan Brown",
    role: "DevOps Engineer",
    avatarUrl: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64/1f468-200d-1f527.png",
  },
  {
    name: "Sophia Lee",
    role: "Data Scientist",
    avatarUrl: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64/1f469-200d-1f52c.png",
  },
];

export default function CandidateSearchCarousel() {
  return (
    <div className="CSC-container">
      {/* Carousel */}
      <div className="CSC-carousel">
        {[...candidates, ...candidates].map((candidate, index) => (
          <div key={index} className="CSC-card">
            <div className="CSC-card-content">
              <div className="CSC-avatar">
                <img
                  className="CSC-avatar-image"
                  src={candidate.avatarUrl}
                  alt={`${candidate.name} avatar`}
                  loading="lazy"
                />
              </div>
              <div>
                <p className="CSC-name">{candidate.name}</p>
                <p className="CSC-role">{candidate.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Search Overlay */}
      <div className="CSC-overlay">
        <div className="CSC-scanner-wrapper">
          <div className="CSC-scanner-circle">
            <Search size={80} color="#5a9bd6" />
          </div>
        </div>
      </div>

      {/* Edge fades */}
      <div className="CSC-fade-left" />
      <div className="CSC-fade-right" />

      <style>{`
        .CSC-container {
          position: relative;
          width: 100%;
          overflow: hidden;
          padding: 48px 0;
          background: linear-gradient(to bottom, #ffffff, #f8fafc);
          top:-30px;
        }

        .CSC-carousel {
          display: flex;
          gap: 24px;
          width: max-content;
          animation: CSC-scroll 34s linear infinite;
        }

        .CSC-card {
          min-width: 260px;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 16px;
          padding: 20px;
          border: 1px solid rgba(0,0,0,0.05);
          box-shadow: 0 8px 24px rgba(0,0,0,0.06);
          backdrop-filter: blur(10px);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .CSC-card:hover {
          transform: translateY(-4px) scale(1.04);
          box-shadow: 0 16px 40px rgba(0,0,0,0.08);
        }

        .CSC-card-content {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .CSC-avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: linear-gradient(135deg, #ffffff, #f3f4f6);
          overflow: hidden;
          flex-shrink: 0;
          border: 1px solid rgba(255,255,255,0.85);
          box-shadow: inset 0 0 0 1px rgba(17,24,39,0.04);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .CSC-avatar-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
          transform: scale(1.08);
        }

        .CSC-name {
          font-size: 14px;
          font-weight: 600;
          color: #111827;
          margin: 0;
        }

        .CSC-role {
          font-size: 12px;
          color: #6b7280;
          margin: 2px 0 0;
        }

        .CSC-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: none;
        }

        .CSC-scanner-wrapper {
          position: relative;
        }

        .CSC-scanner-circle {
          width: 160px;
          height: 160px;
        
        
        
          display: flex;
          align-items: center;
          justify-content: center;
        
          animation: CSC-scan 10s ease-in-out infinite;
        }

        .CSC-fade-left {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 80px;
          background: linear-gradient(to right, #ffffff, transparent);
          pointer-events: none;
        }

        .CSC-fade-right {
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          width: 80px;
          background: linear-gradient(to left, #ffffff, transparent);
          pointer-events: none;
        }

        @keyframes CSC-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @keyframes CSC-scan {
          0% { transform: translateX(-220px); }
          50% { transform: translateX(220px); }
          100% { transform: translateX(-220px); }
        }
      `}</style>
    </div>
  );
}
